<div class="info-page">
  <span class="twc-color-secondary-typeface sub-title"
    ><ng-content select="[sub-title]"></ng-content
  ></span>
  <span class="display-block mt-15 mb-10 twc-color-primary-typeface main-title"
    ><ng-content select="[title]"></ng-content
  ></span>
  <p class="twc-typography-body-1 twc-color-primary-typeface">
    <ng-content select="[text]"></ng-content>
  </p>
</div>
